<div class="radio" *ngIf="config.config.page !== usePage.tile">
    <div>
        <tam-radio [value]="0" [(ngModel)]="focus" (change)="changFocus($event)">
        </tam-radio>
        <span class="radio-span">{{'dashboard.enable_focus_control' | stringLiterals}}</span>
    </div>
    <div class="radio-row">
        <label tam-checkbox [(ngModel)]="enableFocusEntityType" [disabled]="focus !== 0"
            (click)="changeEnableFocusEntityType()">Add Entity Type Filters</label>
        <multi-sel-dropdown-filter [dropdownConfig]="entityTypeConfig">
        </multi-sel-dropdown-filter>
    </div>
    <div class="radio-row">
        <label tam-checkbox [(ngModel)]="enableOneDegree" [disabled]="focus !== 0"
        (click)="changeEnableOneDegree()">{{'dashboard.enable_one_degree' | stringLiterals}}</label>
    </div>
</div>
<div class="radio" *ngIf="config.config.page === usePage.tile">
    <div>
        <tam-radio [value]="0" [(ngModel)]="focus" (change)="changFocus($event)">
        </tam-radio>
        <span class="radio-span">Inherit focus from screen Enable focus control</span>
    </div>
    <div class="radio-row">
        <label tam-checkbox [(ngModel)]="enableFocusRelationType"
            [disabled]="focus !== 0 || config.config.disabledEnabledFocusRelationship"
            (click)="changeEnableFocusRelationType()">
            Add Relationship Filters
        </label>
        <multi-sel-dropdown-filter [dropdownConfig]="focusRelationshipTypeConfig">
        </multi-sel-dropdown-filter>
    </div>
</div>
<div class="radio">
    <div>
        <tam-radio [value]="1" [(ngModel)]="focus" (change)="changFocus($event)"
            [disabled]="config.config.page === usePage.tile && config.config.disabledAllFocus">
        </tam-radio>
        <span class="radio-span">All</span>
    </div>
</div>
<div class="radio">
    <div class="specific">
        <tam-radio [value]="2" [(ngModel)]="focus" (change)="changFocus($event)">
        </tam-radio>
        <tam-entity-dropdown [config]="specificEntityConfig" [disabled]="focus !== 2">
        </tam-entity-dropdown>
    </div>
    <div class="specific-relationship">
        <div class="checkbox-item">
            <label tam-checkbox [(ngModel)]="entityRelationshipType" [disabled]="focus !== 2"
                (click)="changeEntityRelationshipType()">Add Relationship Filters </label>
            <multi-sel-dropdown-filter [dropdownConfig]="entityRelationshipTypeConfig">
            </multi-sel-dropdown-filter>
        </div>
        <div class="checkbox-item">
            <label tam-checkbox [(ngModel)]="includeSpecificEntityItself"
                [disabled]="focus !== 2 || !entityRelationshipType"
                (click)="changeIncludeSpecificEntityItself()">Include specific entity itself</label>
        </div>
    </div>
</div>
<div class="radio">
    <div>
        <tam-radio [value]="3" [(ngModel)]="focus" (change)="changFocus($event)">
        </tam-radio>
        <span class="radio-span">Current User</span>
    </div>
    <div class="radio-row">
        <label tam-checkbox [(ngModel)]="enableCurrentUserRelationship" [disabled]="focus !== 3"
            (click)="changeCurrentUserRelationship()">Add Relationship Filters </label>
        <multi-sel-dropdown-filter [dropdownConfig]="entityCurrentUserRelationshipConfig">
        </multi-sel-dropdown-filter>
    </div>
</div>